export interface StudentBoot {
  account: string;
  basePath: string;
  graphqlPath: string;
  accountName: string;
  themeColor: string;
  token: string;
  tokenExpiresAt: number;
  refreshPath: string;
}

// Injetado pelo Rails em StudentSpa::AppController, num <script
// type="application/json"> lido e removido antes do pack avaliar.
export const readBoot = (): StudentBoot | null => {
  const boot = (window as unknown as {__MILLBODY__?: StudentBoot}).__MILLBODY__;

  return boot && typeof boot.account === 'string' ? boot : null;
};
